export interface Props {
  unicode: string
  title?: string
  className?: string
}

export default function IconFont({ unicode, title, className }: Props) {
  return unicode ? (
    <span
      title={title || undefined}
      style={{
        fontFamily: 'bwi-font',
        fontSize: 'inherit',
        pointerEvents: 'none',
      }}
      className={className}
    >
      {String.fromCodePoint(parseInt(unicode, 16))}
    </span>
  ) : null
}
